/**
 * Demande de consentement Enedis envoyée au client : lien de la page de démarrage et e-mail prérempli (mailto).
 * Titre et texte selon l'agence de l'auteur (12/10/2026) : « Systèmes Solaires » ou « Émeraude Solaire ». Le lien est
 * seul sur sa ligne, entouré de lignes vides, pour que les messageries le rendent cliquable.
 */
export function lienDemarrage(code: string): string {
  return window.location.origin.replace(/\/$/, '') + '/enedis-start/' + code
}

export function societeDeLAgence(agence: string | null | undefined): string {
  return /syst[eè]mes solaires/i.test(agence || '') ? 'Systèmes Solaires' : 'Émeraude Solaire'
}

export function sujetConsentement(agence: string | null | undefined): string {
  return societeDeLAgence(agence) + ' : votre accord pour accéder à vos données Enedis'
}

/** Paragraphes du message ; `null` marque l'emplacement du lien. */
function paragraphes(societe: string): (string | null)[] {
  return [
    'Bonjour,',
    'Pour préparer votre étude photovoltaïque, ' + societe + ' a besoin de votre accord pour consulter auprès d\'Enedis '
      + 'la consommation de votre compteur Linky.',
    'Cliquez sur le lien ci-dessous pour donner votre accord sur votre espace client Enedis :',
    null,
    'Enedis vous présentera l\'application « Retix by EPG », l\'outil d\'étude que nous utilisons.',
    'Cordialement,\r\n' + societe,
  ]
}

export function texteConsentement(lien: string, agence: string | null | undefined): string {
  return paragraphes(societeDeLAgence(agence)).map(p => (p === null ? lien : p)).join('\r\n\r\n')
}

const echapper = (t: string) => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

/** Même message en HTML, avec un vrai lien cliquable (à coller dans un e-mail). */
export function htmlConsentement(lien: string, agence: string | null | undefined): string {
  return paragraphes(societeDeLAgence(agence)).map(p => (p === null
    ? '<p><a href="' + echapper(lien) + '">' + echapper(lien) + '</a></p>'
    : '<p>' + echapper(p).replace(/\r\n/g, '<br>') + '</p>')).join('')
}

export function mailtoConsentement(email: string | null | undefined, lien: string, agence: string | null | undefined): string {
  return 'mailto:' + (email || '') + '?subject=' + encodeURIComponent(sujetConsentement(agence))
    + '&body=' + encodeURIComponent(texteConsentement(lien, agence))
}

/**
 * Copie le message mis en forme (lien cliquable) dans le presse-papiers ; à défaut (navigateur sans copie HTML), le texte.
 * Un brouillon ouvert par « mailto: » n'est que du texte : certaines messageries n'y rendent pas le lien cliquable.
 */
export async function copierMessageConsentement(lien: string, agence: string | null | undefined): Promise<void> {
  const texte = texteConsentement(lien, agence)
  const nav: any = navigator
  const W: any = window
  if (nav.clipboard && nav.clipboard.write && W.ClipboardItem) {
    await nav.clipboard.write([new W.ClipboardItem({
      'text/html': new Blob([htmlConsentement(lien, agence)], { type: 'text/html' }),
      'text/plain': new Blob([texte], { type: 'text/plain' }),
    })])
    return
  }
  await nav.clipboard.writeText(texte)
}
